import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import ExpansionContainer from './ExpansionContainer';

const RootContainer = styled.div`
  width: 100%;
  text-align: justify;
`;

const ContentContainer = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  opacity: 0.6;
  margin-bottom: 24px;
`;

const DetailsContainer = ({ children }) => {
  const isDesktop = useMediaQuery('(min-width: 960px)');

  return (
    <RootContainer>
      {
        isDesktop ? (
          <ContentContainer>
            { children }
          </ContentContainer>
        ) : (
          <ExpansionContainer collapseHeight={88}>
            { children }
          </ExpansionContainer>
        )
      }
    </RootContainer>
  );
};

DetailsContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DetailsContainer;
